import Authors from '@/components/Authors';
import QuoteSVG from '@/svg/icons/quote.svg';
import Paragraph from './Paragraph';

export default function CustomerQuote({ customer }) {
  if (!customer || !customer.bio) return null;

  return (
    <div className="pb-3 md:pb-6 font-sans max-w-xl mx-auto">
      <div className="relative z-20 text-haiti">
        {customer.bio && (
          <blockquote>
            <div className="absolute pin-t pin-l -mt-3 -ml-3">
              <QuoteSVG className="w-10 h-10 text-whisper" />
            </div>

            <div className="relative -mt-3">
              <Paragraph className="text-sm italic font-bold">
                {customer.bio}
              </Paragraph>
            </div>
          </blockquote>
        )}

        <div className="-ml-3 flex items-center md:justify-center w-full">
          <div className="-ml-px">
            <Authors people={[customer]} showTitle />
          </div>
        </div>
      </div>
    </div>
  );
}
